export default "__VITE_ASSET__e0db8716__"